var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTheta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5441_6079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.893555H69.2543V70.1478H0V0.893555Z",
    fill: "#4B5158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2012 15.7842H46.0551V55.2591H23.2012V15.7842Z",
    fill: "#4B5158"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-20.8779 15.7844L23.2004 -28.2939H46.0543L90.1326 15.7844V55.2593L46.0543 99.3376H23.2004L-20.8779 55.2593V15.7844Z",
    fill: "#4B5158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5531 41.7532H36.8205V46.7113H32.55V41.7532H27.8174V37.4828H41.5531V41.7532ZM41.5531 29.5177H36.8205V24.5596H32.55V29.5177H27.8174V33.7881H41.5531V29.5177Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5441_6079"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.893555,
    width: 69.2543,
    height: 69.2543,
    rx: 34.6271,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheta);
export default __webpack_public_path__ + "static/media/theta.6358c1038a42b034ae5cc42f3ff7872f.svg";
export { ForwardRef as ReactComponent };